import { __assign, __rest } from "tslib";
import React from 'react';
import { Channel } from '@at/consumer-web-types';
import { SVG } from '../svg/svg';
import { getLogoSVGData } from './logo.data';
export var Logo = function (_a) {
    var _b = _a.channel, channel = _b === void 0 ? Channel.cars : _b, _c = _a.chevronOnly, chevronOnly = _c === void 0 ? false : _c;
    var channelLogo = getLogoSVGData({ channel: channel, chevronOnly: chevronOnly });
    if (!channelLogo) {
        return null;
    }
    var _d = channelLogo !== null && channelLogo !== void 0 ? channelLogo : {}, paths = _d.paths, width = _d.width, height = _d.height, otherHTMLProperties = __rest(_d, ["paths", "width", "height"]);
    return (React.createElement(SVG, __assign({ svgContent: paths, title: "Autotrader Logo", viewBox: "0 0 ".concat(width, " ").concat(height), width: width, height: height }, otherHTMLProperties)));
};
